module.exports = __webpack_public_path__ + "static/media/Youtube.1c54214a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/agent/Tabs/Payments/img/Youtube.svg
// module id = 385
// module chunks = 16